import { connect } from 'react-redux';
import { isIosMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { IconHandHoldingHand } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { toggleAssistancePanel } from '../../../inklusiva/rolematching/functions';
/**
 * Implementation of a button for toggling fullscreen state.
 */
class RoleMatchingButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.assistance';
        this.toggledAccessibilityLabel = 'toolbar.assistance';
        this.label = 'toolbar.assistance';
        this.toggledLabel = 'toolbar.assistance';
        this.tooltip = 'toolbar.assistance';
        this.toggledTooltip = 'toolbar.assistance';
        this.toggledIcon = IconHandHoldingHand;
        this.icon = IconHandHoldingHand;
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isOpen;
    }
    /**
     * Handles clicking the button, and toggles fullscreen.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(toggleAssistancePanel());
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    return {
        _fullScreen: state['features/toolbox'].fullScreen,
        visible: !isIosMobileBrowser()
    };
};
export default translate(connect(mapStateToProps)(RoleMatchingButton));
